import { VideoSection } from '@kinomap-dev/ng-ui-lib/core';

export function convertVideoSectionToScenicContentTableItem(videoSection: VideoSection): any {
  return {
    id: videoSection.id,
    checkbox: false,
    title: { name: videoSection.name, thumbnail: videoSection.thumbnails.medium },
    country: videoSection.country_start,
    sport: videoSection.sport,
    duration: videoSection.duration,
    distance: videoSection.distance,
    slope: videoSection.positive_slope,
    level: videoSection.difficulty_level,
    status: videoSection.status,
    sessions: videoSection.activities_completed,
    comments: videoSection.comments_count,
    likes: videoSection.likes_count,
    upload: videoSection.added_date,
    labels: ['test', 'my test label', 'is mock'],
  };
}
